<template>
  <v-container id="localLogin">
    <v-row align="center" justify="center">
      <v-col cols="12" md="8" lg="6" xl="4" class="py-0 mb-8">
        <form
          v-if="showTenantsBlock"
          v-on:submit.prevent="pickLocalTenant"
          id="tenant"
        >
          <v-container>
            <!-- Logo -->
            <v-col cols="12">
              <v-img src="/logo.png" aspect-ratio="5" contain></v-img>
            </v-col>
            <v-col cols="12">
              <v-img src="/LogoText.png" aspect-ratio="5" contain></v-img>
            </v-col>

            <v-row justify="center">
              <v-col cols="10">
                <v-autocomplete
                  color="primary"
                  dense
                  solo
                  label='Select Company'
                  :items="tenants"
                  item-text="tenantName"
                  item-value="tenantId"
                  return-object
                  v-model="tenant"
                  v-on:keyup.enter="pickLocalTenant"
                  @change="pickLocalTenant"
                ></v-autocomplete>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <div id="timer">
                  <Timer :onCountdownFinished="this.onCountdownFinished" />
                </div>
              </v-col>
            </v-row>
          </v-container>
        </form>
        <form v-on:submit.prevent="auth" v-else-if="!forgotPasswordBlock" id="login">
          <!-- Logo -->
          <v-col cols="12">
            <v-img src="/logo.png" aspect-ratio="5" contain></v-img>
          </v-col>
          <v-col cols="12">
            <v-img src="/LogoText.png" aspect-ratio="5" contain></v-img>
          </v-col>
          <v-row justify="center">

            <v-col cols="10">
              <v-text-field
                v-model="username"
                :label="labels.username"
                required
                solo
                dense
                hide-details="auto"
              ></v-text-field>
              <v-password-field
                v-model="password"
                :label="labels.password"
                solo
                required
                :keyupEnter="auth"
              ></v-password-field>
              <v-checkbox
                v-if="isResponsive"
                v-model="savePassword"
                :label="labels.savePassword"
                color="white"
                solo
                dense
                class="white--text">
              </v-checkbox>
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-col cols="10">
              <v-row justify="space-between">
                <v-col cols="4" class="mx-4">
                  <v-row>
                    <a 
                      class="forgotPasswordLink"
                      href="#"
                      @click="forgotPasswordHandler"
                      >{{ labels.forgotPasswrd }}</a>
                  </v-row>

                  <v-row>
                    <a 
                      class="policyLink"
                      href="#"
                      @click="$router.push({
                        name: 'privacy'
                      })"
                      >{{ labels.privacyPolicy }}</a>
                  </v-row>
                </v-col>
                <v-col cols="2">
                  <v-btn
                      small
                      color="white"
                      class="font-weight-light"
                      @click="auth"
                      >{{ labels.logIn }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </form>

         <div v-else>
          <!-- Logo -->
          <v-col cols="12">
            <v-img src="/logo.png" aspect-ratio="5" contain></v-img>
          </v-col>
          <v-col cols="12">
            <v-img src="/LogoText.png" aspect-ratio="5" contain></v-img>
          </v-col>
          <v-row justify="center">
            <v-col cols="10">
              <a 
              class="forgotPasswordLink"
              href="#"
              @click="back"
              >{{ labels.back }}</a>

              <ApiForm
                ref="emailForm"
                :formElements="forgotPasswordElements"
                :extractErrorsFn="errors"
                :successFn="success"
                :submit="submit"
                endpoint="account/EmailVerify"
                method="post"
                :useCancel="false"
            />
            <p class="forgorPasswordMessage">
              {{ successForgorPasswordMessage }}
            </p>
            </v-col>
          </v-row>
          </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import store from '@/store/store'
import { mapState } from 'vuex'
import { useLocalAuth, useLocalTenantAuth, onLoginKeyExpiration } from '@/utils/auth/authHelper.js'
import translate from '@/utils/genTable/multilanguageHelper.js'
import Timer from '../../components/timer/Timer.vue'

export default {
  components: {
    Timer
  },
  data() {
    return {
      username: '',
      password: '',
      savePassword: false,
      tenant: {
        tenantName: 'Select tenant..',
        tenantId: null
      },
      labels: {
        logIn: translate('Log in', 'pages.login'),
        forgotPass: translate('Forgot password?', 'pages.login'),
        username: translate('User name', 'pages.login'),
        password: translate('Password', 'pages.login'),
        forgotPasswrd: translate('Forgot password?', 'pages.login'),
        back: translate('Back', 'pages.forgotPassword'),
        privacyPolicy: translate('Privacy Policy', 'pages.login'),
        savePassword: translate('Stay signed in', 'pages.login'),
      },
      forgotPasswordElements: [
        {
          key: 'Email',
          component: 'v-text-field',
          rules: 'required|email',
          label: '$email',
          props: {
            solo: true,
            dense: true,
            hideDetails: 'auto'
          }
        }
      ],
      submit: { text: '$send', color: 'white' },
      forgotPasswordBlock: false,
      successForgorPasswordMessage: '',
      isResponsive: false
    }
  },
  mounted() {
    localStorage.clear()
  },
  methods: {
    auth() {
      useLocalAuth(this.username, this.password, this.savePassword)
    },
    pickLocalTenant() {
      useLocalTenantAuth(this.userState.loginKey, this.tenant.tenantId, this.savePassword)
    },
    forgotPasswordHandler() {
      this.forgotPasswordBlock = true
    },
    back() {
      this.forgotPasswordBlock = false
    },
    errors(data) {
      return data.errors.map(el => {
        return {
          propertyName: el.PropertyName,
          error: el.Error
        }
      })
    },
    success(data) {
      this.$refs.emailForm.resetForm()
      this.successForgorPasswordMessage = translate(
        'A request to change the password has been sent, a reply will be sent to you by email',
        'pages.login'
      )
    },
    onCountdownFinished(){
      onLoginKeyExpiration();
    },
    handleResize(){
      this.isResponsive = document.querySelector('body').clientWidth < 960;
    }
  },
  computed: {
    ...mapState({
      tenants: state => state.user.tenants,
      userState: state => state.user
    }),
    showTenantsBlock: function() {
      if (this.tenants) {
        return this.tenants.length >= 1
      }
    }
  },
  created(){
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  }
}
</script>

<style scoped>
.forgotPasswordLink {
  color: white !important;
  text-decoration: none !important;
}
.forgorPasswordMessage {
  color: white !important;
  font-size: 18px !important;
}
#timer{
  color: white;
  text-align: center;
}
.policyLink{
  color: white !important;
  text-decoration: none !important;
}
.white--text /deep/ label {
  color: white;
}
.white--text /deep/ input {
  border: 1px solid white;
}
</style>
